module.exports = __webpack_public_path__ + "img/Ferguson.7b9938a4.jpg";